import axios from './axios'
// _makeRequest---------------------------------------------------------------------------------------
const _makeRequest = (requestConfig) => {
  return new Promise((resolve, reject) => {

    axios(requestConfig)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        const error = {
          message: err.response ? err.response.data : 'Unknown error try it later',
          code : err.response ? err.response.status || null : null
        };
        reject(error);
      })
  })
};
const getUser = ({token, userID}) => {
  return new Promise((resolve, reject) => {
    const requestConfig = {
      method: 'get',
      url: `/users/${userID}`,
      headers: {
        'Authorization': `Bearer ${token}`
      }
      
    }
    _makeRequest(requestConfig)
      .then(result => {
        resolve(result) // debe llegar token, userId, permisos
      })
      .catch(err => {
          reject(err);
      })
  })
}

const updateUser = ({token, userID, password}) => {
  return new Promise((resolve, reject) => {
    const requestConfig = {
      method: 'patch',
      url: `/users/${userID}`,
      headers: {
        'Authorization': `Bearer ${token}`
      },
      data: {
        password
      }
    }
    _makeRequest(requestConfig)
      .then(result => {
        resolve(result) // debe llegar token, userId, permisos
      })
      .catch(err => {
          reject(err);
      })
  })
}

export default {
  getUser,
  updateUser
}
  